import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Checkbox, Flex, Text } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import Step from "./Step";
import useProgressState from "./useProgressState";
import steps from "./data";
import finishedStep from "./finished";
import ConfigureStep from "./ConfigureStep";

const Stepper = () => {
  const [finished, setFinished] = useState(false);
  const [nextEnable, setNextEnable] = useState(false);
  const { activeStep, getState, onClick, getStatus, setStatus } =
    useProgressState(steps as any);
  const history = useHistory();
  const data = finished ? finishedStep : steps[activeStep];

  useEffect(() => {
    const { buttonNextDisabled } = data;

    if (typeof buttonNextDisabled !== "undefined" && !buttonNextDisabled) {
      setNextEnable(true);
    }
  }, [data]);

  const onConfirmation = (index: number, checked: boolean) => {
    if (!checked) {
      setStatus(index, false);
    }
    setNextEnable(checked);
  };

  const onNext = () => {
    setNextEnable(false);
    setStatus(activeStep, true);
    onClick(activeStep + 1);
  };

  const getButtonNextOnClick = finished
    ? () => history.push("/")
    : activeStep + 1 !== steps.length
    ? () => onNext()
    : () => setFinished(true);

  return (
    <Box mx="auto" p="16px" maxW="780px" minW="740px">
      <Box as="nav" aria-label="Steps" position="relative">
        <Flex
          justify="flex-start"
          align="center"
          as="ol"
          listStyleType="none"
          zIndex={1}
        >
          {finished ? (
            <CheckCircleIcon w={16} h={16} color={"brand.100"} />
          ) : (
            steps.map((step, index) => (
              <Step
                label={step.title}
                key={index}
                index={index}
                state={getState(index)}
                isActive={index === activeStep}
                isCompleted={getStatus(index)}
              >
                {index + 1}
              </Step>
            ))
          )}
        </Flex>
      </Box>
      <ConfigureStep
        title={data.title}
        description={data.description}
        StepComponent={data.StepComponent}
        onConfirmation={(index: number, check: boolean) =>
          onConfirmation(index, check)
        }
        step={activeStep}
        buttonGoBack={data.buttonGoBack}
        buttonGoBackOnclick={() => onClick(activeStep - 1)}
        buttonNext={data.buttonNext}
        buttonNextDisabled={!nextEnable}
        buttonNextLabel={data.buttonNextLabel}
        buttonNextOnclick={() => getButtonNextOnClick()}
        finished={finished}
      />
    </Box>
  );
};

export default Stepper;
